import { Card, CardActionArea, CardContent, CardMedia, Grid, Typography, Container } from "@mui/material";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import teamData from "./teamData";



const Team = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Navbar />
      <Container maxWidth="lg" sx={{ mt: 5, mb: 5 }}>
        <Grid container spacing={4} justifyContent="center">
          {teamData.map((member, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index} data-aos="fade-up">
              <Card
                sx={{
                  textAlign: "center",
                  boxShadow: 3,
                  borderRadius: 3,
                  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                  "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
                }}
              >
                <CardMedia
                  component="img"
                  image={member.image}
                  alt={member.title}
                  sx={{
                    width: 150,
                    height: 150,
                    objectFit: "cover",
                    borderRadius: "50%",
                    mx: "auto",
                    mt: 2,
                  }}
                  loading="lazy"
                />
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {member.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {member.text}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default Team;

